import { http } from "../../utils/config";

/**
 * Hồ sơ tài khoản + OTP. Hàm async thuần (đã bỏ `createAsyncThunk`): không có state
 * nào cần chia sẻ, và cả bốn hàm đều được gọi rồi dùng kết quả ngay tại chỗ.
 *
 * Lỗi để nguyên — nơi gọi dùng `errorMessage()` / `useAction({ form })`.
 * Trước đây `rejectWithValue(error.response.data)` còn làm nổ chính nó khi request
 * không tới được server (`error.response` là undefined -> TypeError trong catch).
 */

export const editUser = (data) =>
  http.post("/auth/api/v1/updateAuth", data).then((res) => res.data);

/**
 * Đổi mật khẩu.
 *
 * LƯU Ý: BE trả HTTP 200 kèm `{ status: 400 }` khi mật khẩu cũ sai, nên nơi gọi
 * phải tự kiểm tra `status` chứ không dựa vào try/catch được.
 */
export const editPassWord = (data) =>
  http.post("/auth/api/v1/resetPassword", data).then((res) => res.data);

export const generaOTP = (data) =>
  http.post("/auth/api/v1/generate-otp", data).then((res) => res.data);

export const checkOTP = (data) =>
  http.post("/auth/api/v1/check-otp", data).then((res) => res.data);
